import axios from 'axios'
import localStoreService from '../util/localStoreService'
import { API_URL } from '../config/config'

export default async function callApi (endpoint, method = 'get', body) {
    try {
        let token = ''
        if (localStoreService.getToken()) {
            token = localStoreService.getToken()
        }

        var dataQuery = {data: body};
        if(method == 'get' || method == 'GET') dataQuery = {params: body}
        const response = await axios({
            method: method,
            url: `${API_URL}/${endpoint}`,
            ...dataQuery,
            headers: {
                'Content-Type': 'application/json',
                'token': token
            }
        })
        return response.data
    } catch (error) {
        if (error.response) {
            if(error.response.status == 403){
                let token = ''
                if (localStoreService.getToken()) {
                    token = localStoreService.getToken()
                }
                if(token){
                    alert('Bạn cần đăng nhập lại để thực hiện chức năng này!');
                }else{
                    alert('Không tìm thấy thông tin đăng nhập trên thiết bị này!');
                }
            }
        }

        return {}
    }
}
